import { useCallback, useState } from 'react';
import { Contract } from 'entities/Contract';

interface HookApi {
  selectedContract: Nullable<Contract>;
  openSendContractClosureNotificationModal: (contract: Contract) => void;
  closeSendContractClosureNotificationModal: () => void;
}

export const useSendContractClosureNotification = (): HookApi => {
  const [selectedContract, setSelectedContract] = useState<Nullable<Contract>>(null);

  const openSendContractClosureNotificationModal = useCallback((contract: Contract): void => {
    setSelectedContract(contract);
  }, []);

  const closeSendContractClosureNotificationModal = useCallback((): void => {
    setSelectedContract(null);
  }, []);

  return {
    selectedContract,
    openSendContractClosureNotificationModal,
    closeSendContractClosureNotificationModal,
  };
};
